import { createStore, RootState } from '@ustra/nuxt/src/vue/store'
export interface HsRootState extends RootState {}
export default () => createStore<HsRootState>({})
